import {Alert, Box, CircularProgress, CssBaseline, Stack} from '@mui/material';
import * as React from 'react';
import Header from '@/components/Header';
import {useUserContext} from '@/components/Providers/UserContext';
import RentalsList from '@/components/RentalsList';
import useFetchRentals from '@/queries/useFetchRentals';
import {type MutateFunctionError} from '@/types/MutateFunctionError';

const MyRentals = () : React.ReactElement => {
    const {user} = useUserContext();
    const rentalsQuery = useFetchRentals();
    const rentalsData = rentalsQuery.data?.data;
    const rentalsInfoMessage = rentalsQuery.data?.message;
    const rentalsInfoErrorCode = rentalsQuery.data?.errorCode;
    const rentalsQueryError = rentalsQuery.error as MutateFunctionError;

    return <React.Fragment>
        <CssBaseline/>
        <Header/>
        <Stack
            sx={{
                flexGrow: 1,
                backgroundColor: '#631d79',
                height: '100%',
            }}
        >
            <Stack
                direction='column'
                justifyContent='flex-start'
                sx={{
                    backgroundColor: '#fff',
                    m: 2,
                    mt: '125px',
                    flexGrow: 1,
                    overflow: 'auto',
                }}
            >
                {(rentalsQuery.isFetching || user === undefined) && <Stack
                    direction='row'
                    justifyContent='center'
                    alignItems='center'
                    sx={{
                        height: '100%',
                    }}
                >
                    <CircularProgress/>
                </Stack>}

                {!rentalsQuery.isFetching && <Stack
                    direction='row'
                    justifyContent='center'
                >
                    {rentalsInfoErrorCode === 0 && rentalsData?.rentals && rentalsData?.rentals.length === 0 && <Alert severity='error' sx={{my: 2}}>No Rentals Found</Alert>}
                    {rentalsQuery.isError && <Alert severity='error' sx={{my: 2}}>{rentalsQueryError.message}</Alert>}
                    {rentalsInfoErrorCode !== 0 && rentalsInfoMessage && <Alert severity='error' sx={{my: 2}}>{rentalsInfoMessage}</Alert>}
                </Stack>}

                {!rentalsQuery.isFetching && rentalsData && rentalsData?.rentals.length > 0 && <Box sx={{width: '100%'}}>
                    <RentalsList
                        rentals={rentalsData?.rentals}
                        user={rentalsData?.user}
                    />
                </Box>}
            </Stack>
        </Stack>
    </React.Fragment>;
};

export default MyRentals;
